import script from "./AreaSelectorMenuBranch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AreaSelectorMenuBranch.vue?vue&type=script&setup=true&lang=ts"

import "./AreaSelectorMenuBranch.vue?vue&type=style&index=0&id=6653dfde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6653dfde"]])

export default __exports__